/**
 * Ryan O'Dowd
 * 2022-04-17
 * © Copyright 2022 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({fonts, globalScale, colors, graphWidth, cellDimension}) => { // @TODO: don't think i should have to pass in graphWidth and cellDimension (and fix globalscale stuff after that)
  const CELL_MARGIN = 2; // @TODO: remove need for this

  return {
    container: {
      display: 'flex',
      marginTop: 8,
      justifyContent: 'center',
      alignItems: 'center',
    },
    monthsLabels: {
      width: '100%',
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginBottom: 4,
    },
    monthLabel: {
      color: colors.white,
    },
    graph: {
      width: graphWidth,
      height: 7 * (cellDimension + (2 * CELL_MARGIN)) + 2, // adding 1 in case there's a month break in this column (and another 1 because for some reason the Pixel 4a [and I assume other devices] have layout issue for this graph)
      display: 'flex',
      flexDirection: 'column',
      flexWrap: 'wrap',
      justifyContent: 'center',
      alignItems: 'center',
    },
    horizontalGraph: {
      flexDirection: 'row',
      height: cellDimension + (2 * CELL_MARGIN),
    },
    graphLabels: {
      width: graphWidth,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
    },
    monthBoundaryTopBorder: {
      borderTopWidth: 1,
      borderColor: colors.white,
    },
    monthBoundaryLeftBorder: {
      borderLeftWidth: 1,
      borderColor: colors.white,
    },
    cell: {
      width: cellDimension,
      height: cellDimension,
      color: colors.white,
      margin: CELL_MARGIN,
      borderRadius: cellDimension / 4,
      justifyContent: 'center',
      alignItems: 'center',
    },
    repairPeanutsRemainingText: {
      marginTop: 8,
      alignSelf: 'center',
      fontSize: 12,
      fontFamily: fonts.primaryBold,
    },
    streakLegend: {
      flex: 1,
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'space-around',
      alignItems: 'center',
      marginTop: 16,
      marginBottom: 8,
    },
    legendItemWrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      paddingLeft: 12,
      paddingRight: 12,
    },
    legendSquare: {
      marginRight: 8,
      marginLeft: 8,
    },
    legendCellSmall: {
      width: cellDimension / 1.4,
      height: cellDimension / 1.4,
      borderRadius: cellDimension / 4, // @TODO: update this to match cells
    },
    cellRepairable: {
      backgroundColor: colors.incorrect,
    },
    cellIcon: {
      fontSize: 18, // @TODO: globalScale? i don't think the contribution graph changes with scale
    },
    cellToday: {
      borderWidth: 3,
      borderColor: colors.lightGray,
    },
    cellSelected: {
      borderBottomWidth: 3,
      borderColor: colors.complete,
    },
    cellFullyRepaired: {
      backgroundColor: colors.accent,
    },
    cellRepairInProgress: {
      backgroundColor: '#FFA500', // @TODO: to globals
    },
    cellCompleted: {
      backgroundColor: colors.accent,
    },
    cellMissedAndFuture: {
      backgroundColor: `${colors.lightGray}77`,
    },
    cellBeforeJoinDate: {
      backgroundColor: colors.primaryDark,
    },
    legendText: {
      fontSize: globalScale * 12,
      color: colors.white,
    },
  };
};

export default getStyles;
